<template>
    <div>
        <div class="language-picker" v-if="languages.length > 1">
            <span v-for="lang in languages" :key="lang" :class="{ active: $store.state.endUser.language === lang }"
                @click="setLanguage(lang)">
                {{ lang.toUpperCase() }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LanguagePicker',

    methods: {
        setLanguage(lang) {
            this.$changeLang(lang)
        },
    },

    computed: {
        languages() {
            const allCards = this.$store.state.layers.map(l => l.cards).flat();
            return allCards.filter((c) => c.published).map(c => c.lang).filter((value, index, self) => self.indexOf(value) === index).sort();
        }
    }
}
</script>